import BasicInfo from './BasicInfo';
import { reduxForm } from 'redux-form';

const ProfileForm = reduxForm({
    form: 'basics',
})(BasicInfo);

export default ProfileForm;